import React from 'react';
import { UgcReviewItem } from './ugc-review-item/ugc-review-item';
import { IUGCReviewsProps } from '@interfaces';
import {
    StyledUGCReviewSection,
    StyledAlReviewsHeader,
} from './ugc-review-item/ugc-review-item.style';
import { DreamlinesButton } from '../../atoms/dreamlines-button/dreamlines-button';
import { theme } from '../../../style/global-style';
import { StyledButtonWrapper, StyledSpinnerWrapper } from '../ugc/ugc.style';
import { __ } from '../../../utils/translation-service';
import { useLoadMore } from '../../../hooks/load-more';
import { CircularProgress } from '@mui/material';

export const UgcReviews = ({ reviews, onShowMore, totalCount }: IUGCReviewsProps) => {
    const { getMoreItems, items, shouldShowButton, isLoading } = useLoadMore(
        onShowMore,
        10,
        reviews,
        totalCount,
    );
    return (
        <StyledUGCReviewSection>
            <StyledAlReviewsHeader>{`Alle Bewertungen (${totalCount}):`}</StyledAlReviewsHeader>
            {items &&
                items.map(({ attributes }, key: number) => {
                    return <UgcReviewItem review={attributes} key={key} />;
                })}
            {shouldShowButton ? (
                isLoading ? (
                    <StyledSpinnerWrapper>
                        <CircularProgress
                            thickness={6}
                            size={25}
                            style={{ color: theme.colors.main4 }}
                        />
                    </StyledSpinnerWrapper>
                ) : (
                    <StyledButtonWrapper>
                        <DreamlinesButton
                            tertiary
                            style={{
                                color: theme.colors.main4,
                                borderColor: theme.colors.main4,
                                backgroundColor: 'transparent',
                            }}
                            onClick={() => getMoreItems()}
                        >
                            {__('loadMore')}
                        </DreamlinesButton>
                    </StyledButtonWrapper>
                )
            ) : null}
        </StyledUGCReviewSection>
    );
};
export default UgcReviews;
